import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { SearchBoxService } from './search-box.service';
import { LogService } from './../../shared';

@Component({
  selector: 'search-box',
  template: require('./search-box.component.html'),
  styles: [require('./search-box.component.scss')],
  providers: [SearchBoxService],
  host: {
    '(document:click)': 'onClick($event)'
  }
})
export class SearchBoxComponent {
  private searchTermStream: Subject<any> = new Subject<any>();
  searchTerm: string = '';
  item: any = null;
  date: string;

  items: Observable<any> = this.searchTermStream
    .debounceTime(100)
    .distinctUntilChanged()
    .switchMap((term: string) => this.service.search(term));

  @Input() id: string;
  @Input() set type(type: string) {
    this.service.setType(type);
  }
  @Input() set display(display: string) {
    this.searchTerm = display;
  }
  @Output() select: EventEmitter<any> = new EventEmitter();

  constructor(private logger: LogService, private router: Router, private service: SearchBoxService) {
    // Do stuff
  }

  onClick($event) {
    if ($event.target.id === this.id.toString() && !this.service.autoOn) {
      this.service.autoOn = true;
    } else if ($event.target.id !== this.id.toString() && this.service.autoOn) {
      this.service.autoOn = false;
    }
  }

  set(item) {
    this.service.autoOn = false;
    this.logger.log('search-box.component', 'set', item);
    this.searchTerm = item.name;
    this.item = item;
    this.select.emit(this.item);
  }

  auto() {
    if (this.searchTerm.length < 3) {
      if (this.service.favorites.length === 0) {
        this.service.autoOn = false;
      } else {
        this.service.autoOn = true;
      }
    } else {
      if (this.service.autoOn === false) {
        this.service.startSearch();
      }
      this.searchTermStream.next(this.searchTerm);
      this.logger.log('search-box.component', 'auto else', this.service.autoOn);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/search-box/search-box.component.ts